import { COLOR } from '@src/styles/color';
import styled from 'styled-components';

export const StyledVoiceCloningList = styled.div`
  .voice-cloning-list-card {
    display: flex;
    justify-content: center;
    margin: 12px 4px;
    min-height: calc(100vh - 120px);
  }

  .voice-cloning-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 1000px;
    width: 100%;
  }

  .voice-search-bar {
    display: flex;
    align-items: center;
    gap: 16px;
    align-self: stretch;
  }

  .voice-search-input {
    flex: 1;

    .MuiOutlinedInput-root {
      font-size: 14px;
    }

    .MuiOutlinedInput-input {
      color: ${COLOR.darkGray};
    }
  }
`;

export const StyledVoiceCloningOption = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const StyledHeaderVoiceList = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
